import { AppStateProvider } from "services/app-state-provider";
import { store } from "store/store";

AppStateProvider.setup(store);
